import loadable from '@loadable/component';

export const SalarySurveyPageLoadable = loadable(
  () => import('./SalarySurveyPage'),
  { resolveComponent: (module) => module.SalarySurveyPage },
);
